import { useAppQuery } from 'data/query-client';
import restClient from 'data/restClient';
import { useAuthToken } from 'hooks/useAuthToken';
import { AllessehContent } from './useAllessehContentQuery';
import { useConvertedProperty } from './useConvertedProperty';

export type AllessehArticleQueryResponse = AllessehContent[];

const getPublicationKeyForWsjOpSearch = (publicationKey: string | null) =>
  publicationKey === 'wsjopinion' ? 'wsj' : publicationKey;

const getAllessehArticleQuery = (authToken: string, contentUrl: string, currentProperty: string | null) =>
  restClient.get<AllessehArticleQueryResponse>('allesseh/article', {
    headers: { Authorization: authToken },
    params: { contentUrl, publicationKey: getPublicationKeyForWsjOpSearch(currentProperty) }
  });

export const useAllessehArticleQuery = (contentUrl: string, options?: { enabled: boolean }) => {
  const authToken = useAuthToken();
  const currentProperty = useConvertedProperty();

  return useAppQuery([contentUrl], () => getAllessehArticleQuery(authToken, contentUrl, currentProperty), options);
};
